function docappCartModifier(cart) {
    if (cart) {
        let modifiedCart = cart
        let customPriceTotal = 0
        let bundlePriceTotal = 0

        cart.items.forEach((item, index) => {
            // if this item is a customize product
            if (item.properties['_customPrice']) {
                customPrice = Number(item.properties['_customPrice']) * 100

                // modify item prices - add custom price
                modifiedCart.items[index].original_price = cart.items[index].original_price + customPrice
                modifiedCart.items[index].price = cart.items[index].price + customPrice // deprecated, but is being used by docapp
                modifiedCart.items[index].final_price = cart.items[index].final_price + customPrice

                // modify line prices - add custom price x item quantity
                modifiedCart.items[index].original_line_price = cart.items[index].original_line_price + customPrice * item.quantity
                modifiedCart.items[index].line_price = cart.items[index].line_price + +(customPrice * item.quantity) // deprecated, but is being used by docapp
                modifiedCart.items[index].final_line_price = cart.items[index].final_line_price + +(customPrice * item.quantity)

                customPriceTotal += customPrice * item.quantity

            } else if (item.properties['_bundleId']) {

                let bundleItemDiscount = Number(item.properties['_bundleLineDiscount']) / Number(item.properties['_bundleLineLength'])
                let bundleLineDiscount = item.quantity * bundleItemDiscount

                // modify item prices
                modifiedCart.items[index].original_price = cart.items[index].original_price - bundleItemDiscount
                // modifiedCart.items[index].price = cart.items[index].price - bundleItemDiscount // deprecated, but is being used by docapp
                modifiedCart.items[index].final_price = cart.items[index].final_price - bundleItemDiscount

                // modify line prices
                modifiedCart.items[index].original_line_price = cart.items[index].original_line_price - bundleLineDiscount
                modifiedCart.items[index].line_price = cart.items[index].line_price - bundleLineDiscount // deprecated, but is being used by docapp
                modifiedCart.items[index].final_line_price = cart.items[index].final_line_price - bundleLineDiscount

                bundlePriceTotal += bundleLineDiscount
                // console.log('bundlePriceTotal', bundlePriceTotal)
            }
        })

        // modify cart prices
        modifiedCart['original_total_price'] = cart.original_total_price + customPriceTotal - bundlePriceTotal
        modifiedCart['items_subtotal_price'] = cart.items_subtotal_price + customPriceTotal - bundlePriceTotal
        modifiedCart['total_price'] = cart.total_price + customPriceTotal - bundlePriceTotal

        return modifiedCart
    }
}

let codes = []

// update the list of codes whenever the app detects a discount code change
document.body.addEventListener('docapp-discount-applied', (e) => {
    codes = []
    e.discounts.forEach((disc) => {
        let code_obj = {}
        code_obj['code'] = disc.title
        code_obj['amount'] = disc.amount
        code_obj['discClass'] = disc.discountClass
        codes.push(code_obj)
    })
})

// custom checkout to use with the Discount on Cart app
const customCheckoutDocApp = async (event) => {
    event.preventDefault()
    const atcBtn = event.target
    const btnText = event.target.innerHTML
    event.target.classList.add('ajax-loading')
    event.target.innerHTML = '<div class="loading-spinner loading-spinner--in-btn"></div>'

    try {
        // fetch the current cart
        const cart = await fetch(`/cart.json`)
        const data = await cart.json()

        // get the app discounted cart
        let modifiedItems
        if (window['discountOnCartProApp'] && window['discountOnCartProApp'].getDiscountedCart()) {
            modifiedItems = await window.discountOnCartProApp.getDiscountedCart().items
            integrateDiscount(modifiedItems, data, atcBtn, btnText)
        } else {
            setTimeout(async () => {
                if (window['discountOnCartProApp'] && window['discountOnCartProApp'].getDiscountedCart()) {
                    modifiedItems = await window.discountOnCartProApp.getDiscountedCart().items
                    integrateDiscount(modifiedItems, data, atcBtn, btnText)
                } else {
                    setTimeout(async () => {
                        modifiedItems = await window.discountOnCartProApp.getDiscountedCart().items
                        integrateDiscount(modifiedItems, data, atcBtn, btnText)
                    }, 2000)
                }
            }, 1000)
        }
    } catch (error) {
        alert('cart: ' + error.message)
    }
}

const integrateDiscount = (modifiedItems, data, atcBtn, btnText) => {
    // calculate the discount allocations
    modifiedItems.forEach((item, index) => {
        // update the modifiedItems key to current cart item key
        item.key = data.items[index].key

        // check if the item is a custom item, if yes split the discounts
        if( data.items[index].properties['_customParent']) {
            // update the _customParent to item key
            data.items[index].properties['_customParent'] = data.items[index].key

            // get the line price for parent and addon
            const parentPrice = data.items[index].original_line_price

            // calculate and assign the discount allocations proportionately
            item['parent_discount'] = Math.round((parentPrice / item.original_line_price) * item.total_discount)
            item['addon_discount'] = item.total_discount - item['parent_discount']
            item['combined_discount'] = item['parent_discount']
        }

        // check if the item is part of a bundle, if yes calculate the combined bundle discount + order discount
        else if( data.items[index].properties['_bundleId']) {
            let bundleDiscount = item.price * item.quantity - item.original_line_price
            item['combined_discount'] = item.total_discount + bundleDiscount
        }

        else {
            item['combined_discount'] = item.total_discount
        }
    })

    // build the payload object
    let cartData = {
        action: 'bundle-draft-order',
        items: JSON.stringify(data.items),
        codes: JSON.stringify(codes),
        app_items: JSON.stringify(modifiedItems),
    }

    // pass the payload to the custom checkout proxy
    $.ajax({
        type: 'POST',
        url: '/apps/integration',
        data: cartData,
        dataType: 'json',
        error: function (error) {
            e = JSON.parse(error.responseText)
            desc = e.description
            alert(desc)
            atcBtn.classList.remove('ajax-loading')
            atcBtn.innerHTML = btnText
        },
        success: function (data) {
            if (data.api === true) {
                if (data.url) {
                    window.location.href = data.url
                } else {
                    alert('Something went wrong. Please contact our customer support.')
                }
            } else {
                alert(data.msg)
            }
            atcBtn.classList.remove('ajax-loading')
            atcBtn.innerHTML = btnText
        },
    })
}
// custom checkout original
const customCheckout = async (event) => {
    event.preventDefault()
    const btnText = event.target.innerHTML
    event.target.classList.add('ajax-loading')
    event.target.innerHTML = '<div class="loading-spinner loading-spinner--in-btn"></div>'

    fetch(`/cart.js`)
        .then((response) => response.json())
        .then(function (data) {
            const cartData = {
                action: 'draft-order',
                items: JSON.stringify(data.items),
            }

            $.ajax({
                type: 'POST',
                url: '/apps/integration',
                data: cartData,
                dataType: 'json',
                error: function (error) {
                    e = JSON.parse(error.responseText)
                    desc = e.description
                    alert(desc)
                    event.target.classList.remove('ajax-loading')
                    event.target.innerHTML = btnText
                },
                success: function (data) {
                    if (data.api === true) {
                        if (data.url) {
                            window.location.href = data.url
                        } else {
                            alert('Something went wrong. Please contact our customer support.')
                        }
                    } else {
                        alert(data.msg)
                    }
                    event.target.classList.remove('ajax-loading')
                    event.target.innerHTML = btnText
                },
            })
        })
}

document.addEventListener('DOMContentLoaded', () => {
    const btnCartPage = document.querySelector('#cartform .checkout-col .button')
    if (btnCartPage) {
        if (window['discountOnCartProApp']) {
            btnCartPage.classList.remove('loading')
        } else {
            setTimeout(() => {
                btnCartPage.classList.remove('loading')
            }, 1500)
        }
    }
})

/* ===== H-OPTIONS-UPGRADE v3 (2026-08-05) — single source of truth ===== */
;(function () {
  'use strict';

  var CARD_DPR = Math.min(window.devicePixelRatio || 1, 2);
  var THUMB_PX = Math.round(72 * CARD_DPR);
  var CARD_PX  = Math.round(150 * CARD_DPR);
  var ZOOM_PX  = 1600;

  var registry = [];
  var built = false;

  function shopifyImg(raw, px) {
    if (!raw) return raw;
    var url = String(raw).trim()
      .replace(/^url\((["']?)([\s\S]*?)\1\)$/i, '$2')
      .replace(/\\(.)/g, '$1')                          // iOS WebKit escapes / . ? = in custom-property values -> un-escape (ROOT CAUSE FIX)
      .replace(/&amp;/gi, '&')
      .replace(/[\s"']+$/g, '')
      .trim();
    try {
      var u = new URL(url, window.location.href);
      var host = u.hostname;
      var allowed = host === 'deconovo.com' || host.endsWith('.deconovo.com') || host === 'cdn.shopify.com';
      var isShopifyImg = /\/cdn\/shop\/(files|products)\//.test(u.pathname) || u.pathname.indexOf('/s/files/') !== -1;
      if (allowed && isShopifyImg) {
        u.protocol = 'https:';
        u.pathname = u.pathname.replace(/_\d+x\d*(?=\.[^./]+$)/i, '');
        u.searchParams.set('width', String(px));
        u.searchParams.delete('format');
        u.searchParams.delete('height');
        return u.href;
      }
      return u.href;
    } catch (e) {
      return url;
    }
  }

  function extractBgUrl(el) {
    var cs = getComputedStyle(el);
    var v = cs.getPropertyValue('--swatch-background-image').trim() || cs.backgroundImage;
    var m = v && v.match(/url\(["']?([^"')]+)["']?\)/);
    return m ? m[1] : null;
  }

  function shortLabel(t) {
    return t.replace(/[（(]([^()（）]*)[)）]/g, function (m, inner) {
      if (/^\s*\+/.test(inner)) return m;
      if (inner.length <= 22) return m;
      return '';
    }).replace(/\s{2,}/g, ' ').trim();
  }

  function collectSwatchLabels() {
    var out = [];
    document.querySelectorAll('.option-selector--swatch .color-swatch.opt-label').forEach(function (label) {
      if (label.__hItem) { out.push(label.__hItem); return; }
      var url = extractBgUrl(label);
      if (!url || url.indexOf('no-image') !== -1) return;
      var input = document.getElementById(label.getAttribute('for')) || label.previousElementSibling;
      var textEl = label.querySelector('.opt-label__text');
      var fullTitle = textEl ? textEl.textContent.trim() : (label.getAttribute('data-swatch') || '');
      if (textEl && label.closest('.product-options') && !label.closest('.Header_Blackout_Curtains')) textEl.textContent = shortLabel(fullTitle);
      var it = {
        label: label,
        input: (input && input.classList && input.classList.contains('opt-btn')) ? input : null,
        url: url,
        title: fullTitle,
        group: label.closest('.option-selector--swatch')
      };
      label.__hItem = it;
      out.push(it);
    });
    return out;
  }

  function upgradeImageSources(items) {
    items.forEach(function (it) {
      if (it.__upgraded) return;
      var card = shopifyImg(it.url, CARD_PX);
      it.zoomUrl  = shopifyImg(it.url, ZOOM_PX);
      it.thumbUrl = shopifyImg(it.url, THUMB_PX);
      it.label.style.setProperty('--swatch-card-image', 'url("' + card + '")');
      it.label.style.setProperty('--swatch-zoom-image', 'url("' + it.zoomUrl + '")');
      if (it.label.closest('.product-options') === null) {
        it.label.style.backgroundImage = 'url("' + card + '")';
      }
      it.__upgraded = true;
    });
  }

  var ZOOM_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="7" stroke="inherit"></circle><line x1="16.5" y1="16.5" x2="21" y2="21"></line><line x1="11" y1="8" x2="11" y2="14"></line><line x1="8" y1="11" x2="14" y2="11"></line></svg>';

  function injectZoomButtons(items) {
    items.forEach(function (it) {
      if (it.label.querySelector('.h-swatch-zoom-btn')) return;
      var btn = document.createElement('span');
      btn.className = 'h-swatch-zoom-btn';
      btn.setAttribute('role', 'button');
      btn.setAttribute('aria-label', 'View larger image');
      btn.innerHTML = ZOOM_SVG;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openModalForLabel(it.label);
      });
      it.label.appendChild(btn);
    });
  }

  var modal, modalImg, modalTitle, modalPrev, modalNext, modalSelect;
  var modalCounter, modalThumbs, modalCaption, modalDownload, modalStage;
  var modalItems = [], modalIdx = 0;
  var pageOverflow = '', bodyOverflow = '', touchStartX = 0;

  function buildModal() {
    modal = document.createElement('div');
    modal.className = 'h-zoom-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Image viewer');
    modal.innerHTML =
      '<div class="h-zoom-modal__panel">'
      + '  <div class="h-zoom-modal__toolbar">'
      + '    <div class="h-zoom-modal__counter" aria-live="polite"></div>'
      + '    <a class="h-zoom-modal__download" aria-label="Download image" download href="#">'
      + '      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3v11m0 0 4-4m-4 4-4-4M5 20h14"/></svg>'
      + '    </a>'
      + '    <button type="button" class="h-zoom-modal__close" aria-label="Close">&#10005;</button>'
      + '  </div>'
      + '  <div class="h-zoom-modal__stage">'
      + '    <button type="button" class="h-zoom-modal__nav h-zoom-modal__nav--prev" aria-label="Previous">&#8249;</button>'
      + '    <img class="h-zoom-modal__img" alt="" decoding="async">'
      + '    <button type="button" class="h-zoom-modal__nav h-zoom-modal__nav--next" aria-label="Next">&#8250;</button>'
      + '  </div>'
      + '  <div class="h-zoom-modal__caption"></div>'
      + '  <div class="h-zoom-modal__thumbs" aria-label="Image thumbnails"></div>'
      + '  <div class="h-zoom-modal__title"></div>'
      + '  <button type="button" class="h-zoom-modal__select">Select this option</button>'
      + '</div>';
    document.body.appendChild(modal);

    modalImg = modal.querySelector('.h-zoom-modal__img');
    modalTitle = modal.querySelector('.h-zoom-modal__title');
    modalPrev = modal.querySelector('.h-zoom-modal__nav--prev');
    modalNext = modal.querySelector('.h-zoom-modal__nav--next');
    modalSelect = modal.querySelector('.h-zoom-modal__select');
    modalCounter = modal.querySelector('.h-zoom-modal__counter');
    modalThumbs = modal.querySelector('.h-zoom-modal__thumbs');
    modalCaption = modal.querySelector('.h-zoom-modal__caption');
    modalDownload = modal.querySelector('.h-zoom-modal__download');
    modalStage = modal.querySelector('.h-zoom-modal__stage');

    modalImg.addEventListener('error', function () {
      var it = modalItems[modalIdx];
      if (it && it.thumbUrl && modalImg.getAttribute('src') !== it.thumbUrl) {
        modalImg.src = it.thumbUrl;
      }
    });

    modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
    modal.querySelector('.h-zoom-modal__close').addEventListener('click', closeModal);
    modalPrev.addEventListener('click', function () { stepModal(-1); });
    modalNext.addEventListener('click', function () { stepModal(1); });
    modalSelect.addEventListener('click', function () {
      var it = modalItems[modalIdx];
      if (it && it.input && !it.input.checked) it.input.click();
      closeModal();
    });
    modalStage.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches && e.changedTouches[0] ? e.changedTouches[0].clientX : 0;
    }, { passive: true });
    modalStage.addEventListener('touchend', function (e) {
      if (!touchStartX || !e.changedTouches || !e.changedTouches[0]) return;
      var delta = e.changedTouches[0].clientX - touchStartX;
      touchStartX = 0;
      if (Math.abs(delta) > 45) stepModal(delta > 0 ? -1 : 1);
    }, { passive: true });
    document.addEventListener('keydown', function (e) {
      if (!modal.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeModal();
      if (e.key === 'ArrowLeft') stepModal(-1);
      if (e.key === 'ArrowRight') stepModal(1);
    });
  }

  function lockModalPage() {
    pageOverflow = document.documentElement.style.overflow;
    bodyOverflow = document.body.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
  }

  function openModalForLabel(label) {
    var it = label.__hItem;
    if (!it) return;
    modal.classList.toggle('h-zoom-modal--preview', !!document.getElementById('PBarNextFrame'));
    var group = it.group;
    modalItems = registry.filter(function (r) { return r.group === group && r.zoomUrl; });
    modalIdx = Math.max(0, modalItems.indexOf(it));
    renderModal();
    modal.classList.add('is-open');
    lockModalPage();
  }

  function openModalSingle(src, title) {
    modal.classList.toggle('h-zoom-modal--preview', !!document.getElementById('PBarNextFrame'));
    modalItems = [{ zoomUrl: src, thumbUrl: src, title: title || '', input: null }];
    modalIdx = 0;
    renderModal();
    modal.classList.add('is-open');
    lockModalPage();
  }

  function stepModal(d) {
    if (modalItems.length < 2) return;
    var mobileViewer = window.matchMedia('(max-width: 767.98px)').matches;
    var n = modalIdx + d;
    if (mobileViewer) n = (n + modalItems.length) % modalItems.length;
    if (!mobileViewer && (n < 0 || n >= modalItems.length)) return;
    modalIdx = n;
    renderModal();
  }

  function renderModalThumbs() {
    modalThumbs.innerHTML = '';
    modalThumbs.classList.toggle('is-scrollable', modalItems.length > 5);
    modalItems.forEach(function (item, index) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'h-zoom-modal__thumb' + (index === modalIdx ? ' is-active' : '');
      button.setAttribute('aria-label', 'View image ' + (index + 1));
      button.setAttribute('aria-current', index === modalIdx ? 'true' : 'false');
      button.style.backgroundImage = 'url("' + (item.thumbUrl || item.zoomUrl) + '")';
      button.style.backgroundSize = 'cover';
      button.style.backgroundPosition = 'center';
      button.style.backgroundRepeat = 'no-repeat';
      button.addEventListener('click', function () { modalIdx = index; renderModal(); });
      modalThumbs.appendChild(button);
    });
  }

  function renderModal() {
    var it = modalItems[modalIdx];
    modalImg.src = it.zoomUrl;
    modalImg.alt = it.title || '';
    modalTitle.textContent = it.title;
    modalCaption.textContent = it.title;
    modalCounter.textContent = (modalIdx + 1) + ' / ' + modalItems.length;
    modalDownload.href = it.zoomUrl;
    var mobileViewer = window.matchMedia('(max-width: 767.98px)').matches;
    modalPrev.disabled = !mobileViewer && modalIdx === 0;
    modalNext.disabled = !mobileViewer && modalIdx === modalItems.length - 1;
    var multi = modalItems.length > 1;
    modalPrev.style.display = multi ? '' : 'none';
    modalNext.style.display = multi ? '' : 'none';
    renderModalThumbs();
    if (it.input) {
      modalSelect.style.display = '';
      var sel = it.input.checked;
      modalSelect.textContent = sel ? 'Selected ✓' : 'Select this option';
      modalSelect.classList.toggle('is-selected', sel);
    } else {
      modalSelect.style.display = 'none';
    }
  }

  function closeModal() {
    modal.classList.remove('is-open');
    document.documentElement.style.overflow = pageOverflow;
    document.body.style.overflow = bodyOverflow;
  }

  function bindSizeGuideZoom() {
    document.querySelectorAll('.product-main .rimage-wrapper img').forEach(function (img) {
      if (img.__hSizeBound) return;
      img.__hSizeBound = true;
      img.addEventListener('click', function () {
        var src = img.currentSrc || img.src;
        openModalSingle(shopifyImg(src, ZOOM_PX), img.alt || '');
      });
    });
  }

  function buildStickyBar() {
    if (document.querySelector('.h-sticky-atc')) return;
    var priceSrc = document.querySelector('#h_price_js .current-price');
    var atcBtn = document.querySelector('.quantity-submit-row__submit .validate-button');
    var buyRow = document.querySelector('.buy-buttons-row');
    if (!priceSrc || !atcBtn || !buyRow) return;

    var bar = document.createElement('div');
    bar.className = 'h-sticky-atc';
    bar.innerHTML =
      '<div class="h-sticky-atc__price">'
      + '  <span class="h-sticky-atc__label">Subtotal</span>'
      + '  <span class="h-sticky-atc__value"></span>'
      + '</div>'
      + '<button type="button" class="h-sticky-atc__btn">Add to Cart</button>';
    document.body.appendChild(bar);

    var valueEl = bar.querySelector('.h-sticky-atc__value');
    function syncPrice() { valueEl.textContent = priceSrc.textContent.trim() || '—'; }
    syncPrice();
    new MutationObserver(syncPrice).observe(priceSrc, { childList: true, subtree: true, characterData: true });

    bar.querySelector('.h-sticky-atc__btn').addEventListener('click', function () {
      atcBtn.click();
      setTimeout(function () {
        var msg = document.querySelector('.validate-options-message');
        if (msg && msg.textContent.trim()) msg.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 120);
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        bar.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { rootMargin: '0px 0px -40px 0px' }).observe(buyRow);
    } else {
      bar.classList.add('is-visible');
    }
  }

  function refresh() {
    if (!document.querySelector('.product-options')) return;
    var items = collectSwatchLabels();
    items.forEach(function (it) { if (registry.indexOf(it) === -1) registry.push(it); });
    upgradeImageSources(items);
    injectZoomButtons(items);
    if (!built) { buildModal(); bindSizeGuideZoom(); buildStickyBar(); built = true; }
  }

  function observeAsyncOptions() {
    var target = document.querySelector('.product-main') || document.body;
    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      (window.requestAnimationFrame || window.setTimeout)(function () {
        scheduled = false;
        refresh();
      });
    }).observe(target, { childList: true, subtree: true });
  }

  function init() {
    refresh();
    observeAsyncOptions();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
/* ===== H-OPTIONS-UPGRADE v3 END ===== */
